/**
 * Created with IntelliJ IDEA.
 * User: Patrick
 * Date: 24.05.12
 * Time: 14:37
 * To change this template use File | Settings | File Templates.
 */

import Shape = createjs.Shape;
import Container = createjs.Container;
/* TODO: @HTML5 ContextMenu Management
 import ContextMenu = createjs.ContextMenu;
 import ContextMenuBuiltInItems = createjs.ContextMenuBuiltInItems;
 import ContextMenuItem = createjs.ContextMenuItem;
 */

export class BasicDebugHud {
    private static CONTEXT_INFO_TEXT_PREFIX: string = "Running in [ ";
    private static CONTEXT_INFO_TEXT_POSTFIX: string = " ] Mode";
    private static DEBUG_MODE_CONTEXT_INFO_TEXT: string = "DEBUG";
    private static TEST_MODE_CONTEXT_INFO_TEXT: string = "Test";

    private static DEBUG_SQUARE_SIZE: number = 4;
    private static DEBUG_SQUARE_HORIZONTAL_GAP: number = 4;

    // TODO: @HTML5 ContextMenu Management
    // private static _contextMenu: ContextMenu;
    private static _xpos: number;
    private static _target: Container;

    private static _awayFromKeyboardStatusPixel: Shape;

    public static showDebugInformationHud(target: Container): void {
        let debugLayer: Container = new Container();
        target.addChild(debugLayer);
        BasicDebugHud._target = debugLayer;

        // Add infos to context menu
        // TODO: @HTML5 ContextMenu Management
        // BasicDebugHud._contextMenu = new ContextMenu();
        BasicDebugHud.removeDefaultItems();

        BasicDebugHud._xpos = 0;

        // Running in test mode?
        BasicDebugHud.displayTestModeViaFlashvarsInfo();

        // Running in debug mode?
        BasicDebugHud.displayDebugModeInfo();

        // TODO: @HTML5 ContextMenu Management
        // BasicDebugHud._target.contextMenu = BasicDebugHud._contextMenu;
    }

    private static removeDefaultItems(): void {
        /* TODO: @HTML5 ContextMenu Management
        BasicDebugHud._contextMenu.hideBuiltInItems();
        let defaultItems: ContextMenuBuiltInItems = BasicDebugHud._contextMenu.builtInItems;
        defaultItems.print = true;
        */
    }

    /**
     *  If the app has been compiled in debug mode (mxmlc argument debug=true), draw a little
     *  pink square in the upper left corner of the screen indicating the app is running in
     *  debug mode.
     */
    private static displayDebugModeInfo(): void {
        // TODO: @HTML5 - need a proper solution for conditional compilation
        /*if (process.env.DEBUG) {
            //----------------------------------
            //	Draw square
            //----------------------------------
            let squareDebug: Shape = new Shape();
            squareDebug.graphics.beginFill("#FF1493");
            squareDebug.graphics.drawRect(BasicDebugHud._xpos, 0, BasicDebugHud.DEBUG_SQUARE_SIZE, BasicDebugHud.DEBUG_SQUARE_SIZE);

            BasicDebugHud._awayFromKeyboardStatusPixel = new Shape();
            BasicDebugHud._awayFromKeyboardStatusPixel.graphics.beginFill("#00FFFF");
            BasicDebugHud._awayFromKeyboardStatusPixel.graphics.drawRect(squareDebug.x + squareDebug.width, 0, squareDebug.width, squareDebug.height);
            BasicDebugHud._awayFromKeyboardStatusPixel.graphics.endFill();

            BasicDebugHud._awayFromKeyboardStatusPixel.visible = false;

            BasicDebugHud._target.addChild(squareDebug);
            BasicDebugHud._target.addChild(BasicDebugHud._awayFromKeyboardStatusPixel);

            // increase xpos
            BasicDebugHud._xpos += BasicDebugHud.DEBUG_SQUARE_HORIZONTAL_GAP;

            //----------------------------------
            //	Add info line to context menu
            //----------------------------------
            let infoText: string = BasicDebugHud.CONTEXT_INFO_TEXT_PREFIX + BasicDebugHud.TEST_MODE_CONTEXT_INFO_TEXT + BasicDebugHud.CONTEXT_INFO_TEXT_POSTFIX;
            /!* TODO: @HTML5 ContextMenu Management
            let ci: ContextMenuItem = new ContextMenuItem(infoText, true);
            BasicDebugHud._contextMenu.customItems.push(ci);
            *!/
        }*/
    }

    /**
     *  If the app runs in test mode (activated with flashvar "test=on")
     *  a little yellow square will be shown
     */
    private static displayTestModeViaFlashvarsInfo(): void {
        if (window.location.href.match(/test=(on|true|1)/)) {
            // if (BasicDebugHud._target.root.loaderInfo.parameters.test == "on") {
            //----------------------------------
            //	Draw square
            //----------------------------------
            let squareTest: Shape = new Shape();
            squareTest.graphics.beginFill("#EEC900");
            squareTest.graphics.drawRect(BasicDebugHud._xpos, 0, BasicDebugHud.DEBUG_SQUARE_SIZE, BasicDebugHud.DEBUG_SQUARE_SIZE);

            BasicDebugHud._target.addChild(squareTest);

            // increase xpos
            BasicDebugHud._xpos += BasicDebugHud.DEBUG_SQUARE_HORIZONTAL_GAP;

            //----------------------------------
            //	Add info line to context menu
            //----------------------------------
            let infoText: string = BasicDebugHud.CONTEXT_INFO_TEXT_PREFIX + BasicDebugHud.DEBUG_MODE_CONTEXT_INFO_TEXT + BasicDebugHud.CONTEXT_INFO_TEXT_POSTFIX;
            /* TODO: @HTML5 ContextMenu Management
            let ci: ContextMenuItem = new ContextMenuItem(infoText, true);
            BasicDebugHud._contextMenu.customItems.push(ci);
            */
        }
    }

    public static updateAwayFromKeyboardPixelVisibility(userIsActive: boolean): void {
        if (BasicDebugHud._awayFromKeyboardStatusPixel) {
            BasicDebugHud._awayFromKeyboardStatusPixel.visible = !userIsActive;
        }
    }
}

